// React
import React from "react";
import PropTypes from "prop-types";
// Assets
import icon from "../../../assets/svgs/info.svg";
// CSS
import "./index.scss";

function Info({ text = "", children = null }) {
  const hasChildren = React.Children.count(children) > 0;

  return (
    <div className="info-box p4">
      <img
        className="info-box__icon"
        src={icon}
        alt="Info"
      />
      <div className="info-box__content">
        {hasChildren ? children : text}
      </div>
    </div>
  );
}

Info.propTypes = {
  /** Plain‐text fallback (for existing usage) */
  text: PropTypes.string,

  /** Preferred: pass in your own JSX */
  children: PropTypes.node,
};


export default Info;
